export default __webpack_public_path__ + "static/media/008-swimming pool.590c0f73.svg";